import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import ja from './locales/ja.json';
import ptBR from './locales/pt-BR.json';
import km from './locales/km.json';
import { mapBackendToI18n } from './utils/languageMapper';

const resources = {
  en: { translation: en },
  ja: { translation: ja },
  'pt-BR': { translation: ptBR },
  km: { translation: km },
};

// Get initial language from localStorage or use default
const getInitialLanguage = (): string => {
  try {
    const persistedState = localStorage.getItem('persist:root');
    if (persistedState) {
      const parsed = JSON.parse(persistedState);
      const appState = JSON.parse(parsed.app || '{}');
      const language = appState.language;

      // If language exists, ensure it's in the correct i18n format
      if (language) {
        return mapBackendToI18n(language);
      }
    }
  } catch (error) {
    console.error('Error loading initial language:', error);
  }
  return 'en';
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    detection: {
      order: ['navigator', 'htmlTag', 'localStorage', 'path', 'subdomain'],
      caches: ['localStorage'],
    },
    lng: getInitialLanguage(), // Use language from Redux state or default
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      useSuspense: false,
    },
  });

// Function to change language dynamically
export const changeI18nLanguage = (language: string) => {
  i18n.changeLanguage(language);
};

export default i18n;
